import React from 'react';
import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';
import Footer from '../../components/shared/Footer';
import PageHelmet from '../../components/shared/PageHelmet';
import HomeAbout from '../Home/HomeAbout/HomeAbout';
import HomeBrands from '../Home/HomeBrands/HomeBrands';
import HomeOneHeader from '../Home/HomeOneHeader/HomeOneHeader';
import HomeTwoFaq from '../Home/HomeTwoFaq/HomeTwoFaq';

const About = () => {
   return (
      <>
         <PageHelmet pageTitle="About JRD Transportation" />

         <HomeOneHeader/>
         <CommonPageHeader title="About Us" subtitle="About" />
         <HomeAbout/>
         <HomeTwoFaq/>
         <HomeBrands/>
         <Footer/>
      </>
   );
};

export default About;